<div class="search-icon-container">
    <button (click)="openSearchModal()" class="btn btn-link white p-0 me-2">
        <i class="fn-global-search"></i>
    </button>
</div>

<!-- Search Modal
<div class="search-modal-content" *ngIf="isModalOpen">
    <span (click)="closeSearchModal()" class="close-btn">&times;</span>
    <input [(ngModel)]="searchTerm" (input)="onSearch()" placeholder="Search menu..." />
    <ul>
        <li *ngFor="let item of searchResults" (click)="navigateTo(item)">
            {{ item.label }}
        </li>
    </ul>
</div> -->

